import React from 'react';
import {BannerRenderProps, IBannerDefinition} from './banner-definition.interface';
import {EmptyBannerComponent} from '../../../../components/cms-banner/empty-banner/empty-banner.component';

export class EmptyBannerDefinition implements IBannerDefinition {

  render(props: BannerRenderProps): React.ReactNode {
    return (<EmptyBannerComponent showPlaceholder={props.showPlaceholder} minHeight={props.minHeight}/>)
  }
}
